export const cleanLines = (md = "") =>
  String(md || "")
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean);

export const stripBoldTitle = (lines = []) => {
  let startIdx = 0;
  for (let i = 0; i < lines.length; i++) {
    if (/^\*\*.*\*\*$/.test(lines[i])) {
      startIdx = i + 1;
      break;
    }
  }
  return lines.slice(startIdx);
};

export const splitSentences = (text = "") => {
  const raw = String(text || "").trim();
  if (!raw) return [];
  const matches = raw.match(/[^.!?]+[.!?]+|[^.!?]+$/g);
  return (matches || []).map((s) => s.trim()).filter(Boolean);
};
